import {Component, Input, OnInit} from '@angular/core';
import {NgSearchInterface} from './ng-search/ng-search.interface';
import {NgSearchTypesEnum} from './ng-search/ng-search-types.enum';
import {NgPureDataTableEventService} from './ng-pure-datatable-event.service';
export class NgPureDatatableComponent implements OnInit {
   key = '';
   id = '';
   disableSearch = false;
   disablePaging = false;
   paginateSettings: paginateSettings = {
    data: {},
    path: '',
    limit: 50,
    from: '',
    perNav: 5,
    viewPage: 'page',
    paginate: 'paginate',
    textColor: '#000'
  };

   searchSettings: NgSearchInterface<Object> = {
    path: null,
    placeholder: 'What are you looking for?',
    data: [],
    searchKeys: [],
    position: 'right',
    positionStyle: {
      right: null,
      top: null,
    },
    width: 40,
    from: null,
    queryField: 'search',
    borderColor: '#eee000',
    buttonColor: '#83e6bc',
    searchType: NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND
  };
public top = 0;
public style = {position: 'absolute', 'margin-bottom': '100px'};
public limitStyle;
public ranges = [];
/**
 * @param {?} ngPureDataTableEventService
 */
constructor(private ngPureDataTableEventService: NgPureDataTableEventService) {
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.paginateSettings['viewPage'] = (!this.paginateSettings['viewPage']) ? 'page' : this.paginateSettings['viewPage'];
    this.paginateSettings['paginate'] = (!this.paginateSettings['paginate']) ? 'paginate' : this.paginateSettings['paginate'];
    this.paginateSettings['from'] = this.key;
    this.searchSettings['from'] = this.key;
    this.searchSettings['position'] = (this.searchSettings['position']) ? this.searchSettings['position'] : 'right';
    this.searchSettings['positionStyle'] = (this.searchSettings['positionStyle']) ? this.searchSettings['positionStyle'] : null;
    this.searchSettings['width'] = (this.searchSettings['width']) ? this.searchSettings['width'] : 40;
    this.paginateSettings['textColor'] = (this.paginateSettings['textColor']) ? this.paginateSettings['textColor'] : '#000';
    this.style['width'] =  this.searchSettings['width'] + '%';
    this.limitStyle = JSON.parse(JSON.stringify(this.style));
    this.limitStyle['width'] =  '200px';
    // console.log('width', this.searchSettings['width'], this.searchSettings['position']);
    this.configSearchDisplay();
    this.processLimit();
  }
/**
 * This is used to generate limit range.
 * @return {?}
 */
processLimit() {
    const /** @type {?} */ div = Math.floor(+this.paginateSettings.limit / 2);
    this.ranges = [];
    let /** @type {?} */ range = 0;
    // console.log('div=', div);
    if ((div % 2) === 0) {
      range = 10;
    } else {
      range = 15;
    }
    const /** @type {?} */ ranges = (range === 10) ? 101 : 106;
    for (let /** @type {?} */ i = range; i < ranges; i+= range) {
      if (i > this.paginateSettings.data['total']) {
        break;
      }
      this.ranges.push(i);
    }
  }
/**
 * This is used to update limit
 * @param {?} limit
 * @return {?}
 */
updateLimit(limit) {
    this.paginateSettings.limit = +limit;
    // console.log('this.paginateSettings.limit', this.paginateSettings.limit);
    this.ngPureDataTableEventService.broadcast('resetLimitCalled', this.paginateSettings.limit);
  }
/**
 * This is used to set the border color for the div
 * @return {?}
 */
public setBorderColor() {
    this.searchSettings.borderColor = (this.searchSettings.borderColor) ? this.searchSettings.borderColor : '#eee000';
    return {'border-bottom': '3px solid ' + this.searchSettings.borderColor};
  }
/**
 * This is used to configure search and limit position
 * @return {?}
 */
configSearchDisplay(): void {
    this.id = (this.id.indexOf('#') > -1) ? this.id : '#' + this.id;
    const /** @type {?} */ element = document.querySelector(this.id);
    this.top = element.getBoundingClientRect().top;
    if (this.top < 50) {
      this.style['margin-top'] = '20px';
      this.limitStyle['margin-top'] = this.style['margin-top'];
      element['style'].marginTop = '80px';
    }
    const /** @type {?} */ right = (this.searchSettings['positionStyle'] && (this.searchSettings['positionStyle']['right'] <= -1 || this.searchSettings['positionStyle']['right'] >= 0)) ? this.searchSettings['positionStyle']['right']: '10px';
    const /** @type {?} */ top = (this.searchSettings['positionStyle'] && (this.searchSettings['positionStyle']['top'] >= 0 || this.searchSettings['positionStyle']['top'] <= -1 )) ? this.searchSettings['positionStyle']['top']: null;

    if (this.searchSettings['position'].toLowerCase() === 'right') {
      this.style['right'] = right + 'px';
      this.limitStyle['left'] =  this.style['right'];
    } else {
      this.style['left'] = right + 'px';
      this.limitStyle['right'] =  this.style['left'];
    }
    this.top = (top) ? top : (this.top && this.top > 50) ? this.top - 50 : this.top;
    this.style['top'] = this.top + 'px';
    this.limitStyle['top'] = this.style['top'];
   // console.log('element=', element.getBoundingClientRect().top);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng-pure-datatable',
  template: `
    <div *ngIf="paginateSettings.data">

      <div class="limit-style" *ngIf="limitStyle && !disablePaging" [ngStyle]="limitStyle">
        <!--<label for="limit">Limit: </label>-->
        <select id="limit" [ngStyle]="setBorderColor()" [(ngModel)]="paginateSettings.limit"
                (change)="updateLimit(+limit.value)" #limit>
          <option value="" disabled selected>Select Limit</option>
          <option *ngFor="let num of ranges" value="{{num}}">{{num}}</option>
        </select>
      </div>
      <div class="search-app" *ngIf="!disableSearch" [ngStyle]="style">
        <ng-search [allSettings]="searchSettings"></ng-search>
        <div style="clear: both;"></div>
      </div>

      <ng-paginate *ngIf="!disablePaging" [from]="paginateSettings.from" [data]="paginateSettings.data"
                   [path]="paginateSettings.path"
                   [limit]="paginateSettings.limit" [perNav]="paginateSettings.perNav"
                   [viewPage]="paginateSettings.viewPage" [paginate]="paginateSettings.paginate"
                   [textColor]="paginateSettings.textColor"></ng-paginate>
    </div>
  `,
  styles: [`
    select {
      width: 100% !important;
      height: 30px !important;
      padding: 5px !important;
      color: #000 !important;
      border: 1px solid #ccc;
      border-bottom: 3px solid #eee000;
    }


    select:visited, select:active, select:link, select:after, select:hover, select:focus, button:focus {
      outline: none;
    }


    @media (max-width: 768px) {
      .search-app {
        width: 55% !important;
      }
      .limit-style {
        width: 100px !important;
      }
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgPureDataTableEventService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'key': [{ type: Input },],
'id': [{ type: Input },],
'disableSearch': [{ type: Input },],
'disablePaging': [{ type: Input },],
'paginateSettings': [{ type: Input },],
'searchSettings': [{ type: Input },],
};
}

function NgPureDatatableComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgPureDatatableComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPureDatatableComponent.ctorParameters;
/** @type {?} */
NgPureDatatableComponent.propDecorators;
/** @type {?} */
NgPureDatatableComponent.prototype.key;
/** @type {?} */
NgPureDatatableComponent.prototype.id;
/** @type {?} */
NgPureDatatableComponent.prototype.disableSearch;
/** @type {?} */
NgPureDatatableComponent.prototype.disablePaging;
/** @type {?} */
NgPureDatatableComponent.prototype.paginateSettings;
/** @type {?} */
NgPureDatatableComponent.prototype.searchSettings;
/** @type {?} */
NgPureDatatableComponent.prototype.top;
/** @type {?} */
NgPureDatatableComponent.prototype.style;
/** @type {?} */
NgPureDatatableComponent.prototype.limitStyle;
/** @type {?} */
NgPureDatatableComponent.prototype.ranges;
/** @type {?} */
NgPureDatatableComponent.prototype.ngPureDataTableEventService;
}


export interface paginateSettings {
  data: Object;
  path: string;
  limit: number;
  from: string;
  perNav: number;
  viewPage: string;
  paginate: string;
  textColor: string;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
